import { useAppDispatch } from 'store/hooks';

import { showToast } from 'helpers/showToast';
import { getUnknownErrorMessage } from 'helpers/unknownErrorMessage';
import { scrollToTop } from 'helpers/scrollToTop';

export const usePagination = ({
  dataAction,
  data = {},
  totalPages,
  currentPage,
  perPage,
  sortBy,
  sortDirection,
}: {
  dataAction: any;
  data?: any;
  totalPages: any;
  currentPage: any;
  perPage: any;
  sortBy: any;
  sortDirection: any;
}) => {
  const dispatch = useAppDispatch();

  const handlePerPageChange = async (nextPerPage: any) => {
    try {
      scrollToTop('.menu-layout-container');
      await dispatch(
        dataAction({
          ...data,
          page: 1,
          limit: nextPerPage,
          sortBy: sortBy || 'createdAt',
          sortDirection: sortDirection || 'desc',
        }),
      ).unwrap();
    } catch (error) {
      console.warn(error);

      showToast({
        data: {
          variant: 'error',
          title: 'Error!',
          text: getUnknownErrorMessage(error, 'Server error'),
        },
      });
    }
  };

  const handleNextPageClick = async () => {
    try {
      const nextPage = currentPage + 1;

      if (nextPage > totalPages) {
        return;
      }

      scrollToTop('.menu-layout-container');

      await dispatch(
        dataAction({
          ...data,
          page: nextPage,
          limit: perPage,
          sortBy: sortBy || 'createdAt',
          sortDirection: sortDirection || 'desc',
        }),
      ).unwrap();
    } catch (error) {
      console.warn(error);

      showToast({
        data: {
          variant: 'error',
          title: 'Error!',
          text: getUnknownErrorMessage(error, 'Server error'),
        },
      });
    }
  };

  const handlePrevPageClick = async () => {
    try {
      const prevPage = currentPage - 1;

      if (prevPage === 0) {
        return;
      }

      scrollToTop('.menu-layout-container');

      await dispatch(
        dataAction({
          ...data,
          page: prevPage,
          limit: perPage,
          sortBy: sortBy || 'createdAt',
          sortDirection: sortDirection || 'desc',
        }),
      ).unwrap();
    } catch (error) {
      console.warn(error);

      showToast({
        data: {
          variant: 'error',
          title: 'Error!',
          text: getUnknownErrorMessage(error, 'Server error'),
        },
      });
    }
  };

  return [handlePerPageChange, handlePrevPageClick, handleNextPageClick];
};
